import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeycloakService, KeycloakBearerInterceptor } from 'keycloak-angular';
import { Observable } from 'rxjs';
import { config } from 'src/app/config/api.config';
@Injectable({
  providedIn: 'root',
})
export class RequestInterceptorService implements HttpInterceptor {
  cohorte: any;
  constructor(private keycloakService: KeycloakService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (
      !this.keycloakService.isLoggedIn ||
      req.url.includes(config.openBaseUrl + '/opencontroller/')
    ) {
      return next.handle(req);
    }
    // console.log(this.keycloakService.getKeycloakInstance().token);
    if (req.url.includes(config.apiBaseUrl + '/deliberation/')) {
      this.cohorte = sessionStorage.getItem('cohorte');
      // console.log(this.keycloakService.getKeycloakInstance().token);
      let headers: any = {
        Authorization:
          'Bearer ' + this.keycloakService.getKeycloakInstance().token,
      };
      if (this.cohorte) {
        headers.cohorte = this.cohorte;
      }
      let request = req.clone({
        setHeaders: headers,
      });
      //console.log(request.headers)
      return next.handle(request);
    } else {
      // console.log(this.keycloakService.getKeycloakInstance().token);
      console.log(this.keycloakService.getKeycloakInstance().token);
      let request = req.clone({
        setHeaders: {
          Authorization:
            'Bearer ' + this.keycloakService.getKeycloakInstance().token,
        },
      });
      return next.handle(request);
    }
  }
}
